import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "empty-channel" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-chat-text",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.678 11.894a1 1 0 0 1 .287.801 10.97 10.97 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8.06 8.06 0 0 0 8 14c3.996 0 7-2.807 7-6 0-3.192-3.004-6-7-6S1 4.808 1 8c0 1.468.617 2.83 1.678 3.894zm-.493 3.905a21.682 21.682 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a9.68 9.68 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8zm0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1)
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_ctx.title)
        ? (_openBlock(), _createBlock("h5", _hoisted_4, _toDisplayString(_ctx.$t('no')) + " " + _toDisplayString(_ctx.title) + " " + _toDisplayString(_ctx.$t('yet')), 1))
        : _createCommentVNode("", true),
      (_ctx.heading)
        ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('heading')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}